module.exports = __webpack_public_path__ + "img/icb-empty-Adv-e@2x.9e949e3b.png";